import { Paper, Typography } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { AuthContext } from "~/auth/AuthProvider";
import { RetryButton } from "~/components/Buttons";
import SpacedGridContainer from "~/components/SpacedGridContainer";
import SpacedGridItem from "~/components/SpacedGridItem";
import Config from "~/config";

const Forbidden = () => {
	const { t } = useTranslation("common");
	const authContext = useContext(AuthContext);

	return (
		<Paper sx={{ padding: "1em", textAlign: "center" }}>
			<SpacedGridContainer>
				<SpacedGridItem maxCols={1} smMargin>
					<Typography variant="h6">{t("errorPages.forbidden.message")}</Typography>
				</SpacedGridItem>
				<SpacedGridItem maxCols={1} smMargin>
					<RetryButton onClick={() => authContext.redirectToLogout()} variant="contained">
						{t("errorPages.forbidden.tryAgain")}
					</RetryButton>
				</SpacedGridItem>
				<SpacedGridItem maxCols={1} smMargin>
					<p>{t("errorPages.forbidden.buildVersion", { version: Config.buildVersion })}</p>
				</SpacedGridItem>
			</SpacedGridContainer>
		</Paper>
	);
};
export default Forbidden;
